// extracted by mini-css-extract-plugin
module.exports = {"downloadApp":"styles_downloadApp__2OiMP","desktop":"styles_desktop__3G0ps","mobile":"styles_mobile__18936","img":"styles_img__boaer"};